import { useEffect, useState } from 'react'
import cn from 'classnames'
import ReactMarkdown from 'react-markdown'
import defaultTheme from 'tailwindcss/defaultTheme'

import SmartphonesBgPng from '../../assets/images/smartphones_bg.png'
import CloseCirclePng from '../../assets/images/close_circle.png'
import AvatarBigPng from '../../assets/images/avatar_big.png'
import Bot from '../../components/Bot'
import BotContextProvider from '../../contexts/BotContext'
import MainLayout from '../../layouts/MainLayout'

import './styles.css'
import { INITIAL_CHAT_MESSAGES } from '../../contexts/BotContext/config'

const Home = () => {
  const [isBotOpen, setIsBotOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const updateIsMobile = () => {
      const windowWidth = window.innerWidth
      const mdWidth = +defaultTheme.screens.md.replace('px', '')

      const newIsMobile = windowWidth < mdWidth

      setIsMobile(newIsMobile)
    }

    window.addEventListener('resize', updateIsMobile)

    updateIsMobile()

    return () => {
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [])

  return (
    <MainLayout>
      <main className="w-full h-full bg-gray-150 relative overflow-y-auto">
        <div className="w-full h-full relative md:container md:mx-auto">
          <div className="hidden md:flex pt-24 flex-col items-center text-center">
            <h1 className="font-bold font-brand text-3xl mb-2">Pipa</h1>

            <p className="text-2xl max-w-lg inline-block mb-10">
              Sua assistente digital de vinhos que vai ajudar você a escolher o vinho ideal para o seu momento.
            </p>

            <img src={SmartphonesBgPng} alt="Smartphone com imagens de vinhos" className="app-smartphones-image" />
          </div>

          <div className="fixed top-0 left-0 w-full h-full md:h-auto md:w-auto md:top-auto md:left-auto md:bottom-0 md:right-0 mr-4">
            {(isMobile || isBotOpen) && (
              <div className="bg-white w-full md:max-w-sm overflow-hidden md:rounded-3xl app-bot-container">
                <BotContextProvider>
                  <Bot />
                </BotContextProvider>
              </div>
            )}

            <div className="hidden md:inline-flex w-full justify-end mt-4 mb-7">
              <div className="relative">
                {!isBotOpen && (
                  <div className="absolute right-full p-2 -mt-18 -mr-5 bg-white text-sm rounded-lg rounded-br-none app-avatar-chat-box">
                    <ReactMarkdown>
                      {INITIAL_CHAT_MESSAGES[0]}
                    </ReactMarkdown>
                  </div>
                )}

                <button
                  onClick={() => setIsBotOpen(!isBotOpen)}
                  className={cn('rounded-full px-3 app-avatar-button focus:outline-none', { active: isBotOpen })}
                >
                  <div className={cn('flex items-end justify-center', {
                    'rounded-full bg-white items-end app-avatar-image': !isBotOpen,
                    'items-center': isBotOpen
                  })}>
                    <img
                      src={isBotOpen ? CloseCirclePng : AvatarBigPng}
                      alt={isBotOpen ? 'Sair da conversa' : 'Converse com a Pipa'}
                    />
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </MainLayout>
  )
}

export default Home
